import type { Ref } from 'react';
import { forwardRef } from 'react';

import type { TIconSize } from '../icon.interface';
const VisaMyCard = forwardRef(
  ({ ...props }: TIconSize, ref: Ref<SVGSVGElement>) => {
    return (
      <svg
        width="35"
        height="24"
        viewBox="0 0 35 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={ref}
        {...props}
      >
        <g style={{ mixBlendMode: 'luminosity' }}>
          <path
            d="M14.3906 7.16653L10.4625 16.3285H7.9L5.96719 9.01818C5.85 8.56749 5.74844 8.40249 5.39062 8.21305C4.80781 7.90444 3.84531 7.61416 3 7.43389L3.05781 7.16805H7.18281C7.70781 7.16805 8.18125 7.51027 8.3 8.10305L9.32031 13.4044L11.8438 7.16805H14.3906V7.16653ZM24.4297 13.3387C24.4406 10.9203 21.0094 10.7873 21.0328 9.7072C21.0406 9.37873 21.3609 9.02888 22.0609 8.94026C22.4078 8.89596 23.3656 8.86235 24.4516 9.34971L24.8766 7.40639C24.2937 7.20014 23.5422 7 22.6094 7C20.2125 7 18.5266 8.24513 18.5125 10.0296C18.4969 11.348 19.7156 12.0844 20.6344 12.5229C21.5797 12.972 21.8969 13.2608 21.8922 13.6611C21.8859 14.2752 21.1391 14.5472 20.4406 14.5579C19.2219 14.5762 18.5156 14.2355 17.9516 13.9788L17.5125 15.9863C18.0781 16.2399 19.125 16.4615 20.2078 16.4737C22.7563 16.4737 24.4219 15.2438 24.4297 13.3387ZM30.7578 16.3301H33L31.0422 7.16653H28.9734C28.5078 7.16653 28.1156 7.43083 27.9422 7.83874L24.3047 16.3285H26.85L27.3563 14.9597H30.4656L30.7578 16.3301ZM28.0531 13.0836L29.3297 9.64304L30.0641 13.0836H28.0531ZM17.8531 7.16653L15.8484 16.3285H13.425L15.4297 7.16653H17.8531Z"
            fill="#0041D6"
          />
        </g>
      </svg>
    );
  }
);
export default VisaMyCard;
